// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
const configElement = document.getElementById('config')
const configFromHtml = JSON.parse(configElement.innerHTML)
console.log('config', configFromHtml)
window.configECP = configFromHtml

/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './state/store'
import './assets/fonts/font-awesome/css/all.min.css'
// import './scss/helpers/_variables.scss'
import './scss/blue.scss'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueWait from 'vue-wait'
import vuexI18n from 'vuex-i18n'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import { API } from './api/axios'

window.getUrlVars = () => {
  var vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value
  })
  return vars
}

async function loadTheme (t) {
  if (t === 'red') {
    // return import(/* webpackChunkName: "red" */ './scss/red.scss')
  } else if (t === 'green') {
    // return import(/* webpackChunkName: "green" */ './scss/green.scss')
  }
}

let theme = window.getUrlVars()['theme']
console.log('theme', theme)
loadTheme(theme)


global.$ = window.$ = window.jQuery = require('jquery')

window.Tether = require('tether')
require('bootstrap')
Vue.use(vuexI18n.plugin, store,
  {
    moduleName: 'i18n',
    onTranslationNotFound (locale, key) {
      // console.warn(`i18n::Key '${key}' not found for locale '${locale}'`)
      return `***${key}***`
    },
  },
)

Vue.use(VueWait)
Vue.use(VeeValidate)
Vue.use(VueGoogleMaps)

API.get('/apiconfiguration')
  .then(response => {
    // eslint-disable-next-line no-unused-vars
    let apiKey = response.data.GoogleMapsApiKey

    VueGoogleMaps.load({
      key: apiKey,
      libraries: 'places', // necessary for places input
    })
  })

window.loadTranslation = (lang) => {
  API.get('/translations/' + lang)
    .then(response => {
      let apiTranslations = response.data
      Vue.i18n.add(lang, apiTranslations)
    })
}

window.loadTranslation('en')
window.loadTranslation('nl')
window.loadTranslation('de')

window.getBrowserLanguage = () => {
  let userLanguage = navigator.language
  if (userLanguage !== undefined) {
    let language = userLanguage.substring(0, 2)
    if (!(Vue.i18n.localeExists(language))) {
      return 'en'
    }
    return language
  } else {
    return 'en'
  }
}

router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  let language = to.params.lang

  if (!language) {
    language = window.getBrowserLanguage()
  }

  store.commit('changeLanguage', language)
  Vue.i18n.set(language)
  next()
})

Vue.config.productionTip = false

Vue.filter('datetime', function (value) {
  if (!value) return ''

  return moment(value).format('YYYY-MM-DD HH:mm')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  wait: new VueWait({
    useVuex: true,
  }),
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js